(function () {
  if (window.__hlCartRelated) return;
  window.__hlCartRelated = true;

  /* A small horizontal rail of related products, above the discount block in the
     cart drawer. Owner, 2026-09-12: "Thêm các related products ở trên discount
     code, nhỏ thôi (nằm ngang, scroll ngang thôi, tự động load thêm khi user add
     to cart 1 món khác)".

     THIS IS NOT hl-cart-upsell COMING BACK. That snippet is still on the theme
     and still stood down; it carries a bundle-progress line and, more to the
     point, a QUICK-VIEW SHEET. The sheet is the surface that produced the worst
     defect this project has found — a variant picker inside it driving the PAGE's
     product into the cart — and hl-sticky-cart's hlIsPagePicker() exists only to
     stop that. Nothing here opens a sheet, so that whole class of bug cannot
     occur; see the note on card() for what a card does instead.

     THREE THINGS THAT COST THIS PROJECT TIME AND ARE DESIGNED FOR HERE:

     1. THE OBSERVER FEEDBACK LOOP. The earlier rail cleared and re-appended its
        cards on every refresh, unconditionally, while hl-cart-polish rewrote its
        tier ladder on every pass; each one's writes woke the other's observer and
        an open, untouched drawer issued 11 /cart.js requests per 15 idle seconds
        against live's 0. hl-cart-polish is gone, but the trigger the owner is
        asking for — refresh when another item is added — is the same trigger that
        fed it. So: the rail rebuilds ONLY when the list of product ids changes
        (`rail.dataset.hlKey`), and the observer below ignores anything inside our
        own wrapper.

     2. NOTHING FETCHES /cart.js. The seed used to come from a /cart.js read on
        every refresh. It comes from the drawer's own DOM now — the line items are
        links to /products/<handle> — so the count cart_idle_test watches is
        structurally zero rather than merely small. Product ids are resolved once
        per handle from /products/<handle>.js and cached for the session.

     3. NO VISUALLY-HIDDEN TEXT INSIDE THE SCROLLER. A visually-hidden <span>
        placed in a horizontal scroller on this store once took body.scrollWidth
        from 433 to 2972: off-screen text is still laid out, and in a flex row it
        is laid out sideways. Every name here is an attribute. */

  var CARDS = 4;
  /* "load thêm" — how far the rail can grow once the shopper scrolls it, 2026-09-22.
     The first paint stays at CARDS so the measured 98px rail and its first-open
     cost are untouched: nothing below runs until a finger or a wheel moves the
     track. MAX_CARDS is a ceiling rather than a target — Shopify's
     /recommendations endpoint tops out at 10 per intent, and the second intent
     rarely adds more than a handful once duplicates are dropped, so in practice
     the rail settles well under it. It exists so the loop provably terminates. */
  var MORE_STEP = 4;
  var MAX_CARDS = 16;
  /* Append when the track is within this many pixels of its end. One card plus a
     gap is 108px on the accepted geometry, so ~1.5 cards of runway: enough that
     the next card is already drawn when it scrolls into view, not so much that a
     rail nobody is scrolling loads anything. */
  var MORE_AHEAD = 160;
  /* Drawn here rather than pulled from an icon sheet: this file has to work with
     no other hl-* snippet rendered, which is the state the cart is in. */
  /* THE STORE'S OWN ADD-TO-CART GLYPH, path for path from
     assets/icon-add-to-cart.svg — the file the PDP's add-to-cart button renders
     (add-to-cart-button.liquid:50). Owner: "dùng icon add to cart trong PDP".
     It was a bag-with-plus of this file's own drawing before, close but not the
     same shape. The one variable the asset uses, --icon-stroke-width, is given a
     literal here because this markup is built in JS outside the theme's icon
     wrapper that would otherwise supply it. */
  var ICON_BAG = '<svg viewBox="0 0 20 20" fill="none" aria-hidden="true">'
    + '<path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"'
    + ' d="M16.608 9.421V6.906H3.392v8.016c0 .567.224 1.112.624 1.513.4.402.941.627 1.506.627H8.63'
    + 'M8.818 3h2.333c.618 0 1.212.247 1.649.686a2.35 2.35 0 0 1 .683 1.658v1.562H6.486V5.344'
    + 'c0-.622.246-1.218.683-1.658A2.33 2.33 0 0 1 8.82 3"/>'
    + '<path stroke="currentColor" stroke-linecap="round" stroke-width="1.5"'
    + ' d="M14.608 12.563v5m2.5-2.5h-5"/></svg>';
  var ICON_GONE = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"'
    + ' stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';
  var ICON_TICK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"'
    + ' stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">'
    + '<path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';
  var recCache = {};      // product id -> products[]
  var idCache = {};       // handle -> product id
  var busy = false;
  var pending = false;

  function money(cents) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US',
        { style: 'currency', currency: cur }).format(cents / 100);
    } catch (e) { return '$' + (cents / 100).toFixed(2); }
  }

  /* THE EMPTY CART GETS A GALLERY (2026-10-01). Recommendations are SEEDED by a product in the
     cart, so with nothing in it the rail has nothing to ask about. The owner's call: do not copy the
     rail there; show a plain gallery of the store's best sellers instead -- the one moment a shopper
     has opened the cart and has nothing in it is when something to look at is most useful. */
  var emptyCache = null;
  function isEmptyDrawer(drawer) { return !!drawer.querySelector('.cart-drawer--empty'); }

  /* /collections/<x>/products.json speaks dollars-as-strings and {images:[{src}]}; card() speaks the
     /recommendations shape (cents, featured_image, available). Convert once, here. */
  function cents(v) { var n = parseFloat(v); return isFinite(n) ? Math.round(n * 100) : 0; }
  function asRec(p) {
    var vs = p.variants || [];
    var prices = vs.map(function (v) { return cents(v.price); }).filter(Boolean);
    var was = vs.map(function (v) { return v.compare_at_price ? cents(v.compare_at_price) : 0; }).filter(Boolean);
    var lo = prices.length ? Math.min.apply(null, prices) : 0;
    var hi = prices.length ? Math.max.apply(null, prices) : 0;
    var img = p.images && p.images[0] && p.images[0].src || '';
    return {
      id: p.id, handle: p.handle, title: p.title,
      featured_image: img,
      images: (p.images || []).map(function (i) { return i.src; }),
      price: lo, price_min: lo, price_max: hi,
      compare_at_price_min: was.length ? Math.min.apply(null, was) : null,
      available: vs.some(function (v) { return v.available; }),
      variants: vs.map(function (v) { return { id: v.id, available: v.available }; })
    };
  }
  function getJson(url) {
    return fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .catch(function () { return { products: [] }; });
  }
  function fetchEmptyPool() {
    if (emptyCache) return Promise.resolve(emptyCache);
    return getJson('/collections/best-sellers/products.json?limit=16').then(function (d) {
      var list = (d.products || []).map(asRec);
      if (list.length >= 4) return list;
      /* a thin collection is topped up from the whole catalogue, deduped */
      return getJson('/collections/all/products.json?limit=16').then(function (a) {
        var seen = {}; list.forEach(function (p) { seen[p.id] = 1; });
        (a.products || []).forEach(function (p) { if (!seen[p.id]) list.push(asRec(p)); });
        return list;
      });
    }).then(function (list) { emptyCache = list; return list; });
  }

  var galBox = null, galBusy = false;
  var GAL_MAX = 8;
  function removeGallery() {
    if (galBox && galBox.isConnected) {
      var host = galBox.parentNode;
      galBox.remove();
      if (host && host.classList) host.classList.remove('hl-has-gal');
    }
  }
  function galCard(p) {
    var img = p.featured_image || '';
    var w1 = '', w2 = '';
    if (img) {
      var sep = img.indexOf('?') === -1 ? '?' : '&';
      w1 = img + sep + 'width=360';
      w2 = img + sep + 'width=720';
    }
    var lo = p.price_min != null ? p.price_min : p.price;
    var hi = p.price_max != null ? p.price_max : p.price;
    var price = hi > lo ? 'From ' + money(lo) : money(lo);
    var was = p.compare_at_price_min;
    var wasHtml = (was != null && was > lo) ? '<s class="hl-gal__was">' + money(was) + '</s> ' : '';
    var a = el('a', 'hl-gal__card');
    a.href = '/products/' + p.handle;
    a.innerHTML =
      '<span class="hl-gal__img">' +
        (img ? '<img src="' + w1 + '" srcset="' + w1 + ' 360w, ' + w2 + ' 720w" sizes="(min-width: 750px) 220px, 44vw"'
             + ' alt="" loading="lazy" width="360" height="360">' : '') +
      '</span>' +
      '<span class="hl-gal__title"></span>' +
      '<span class="hl-gal__price">' + wasHtml + '<span class="hl-gal__now">' + price + '</span></span>';
    a.querySelector('.hl-gal__title').textContent = p.title;
    a.setAttribute('aria-label', p.title + ', ' + price);
    return a;
  }
  function renderGallery(drawer) {
    var content = drawer.querySelector('.cart-drawer--empty .cart-drawer__content');
    if (!content) return;
    if (!galBox) {
      galBox = el('section', 'hl-gal');
      galBox.hidden = true;
      galBox.innerHTML = '<p class="hl-gal__h" id="hl-gal-h">Best sellers</p><div class="hl-gal__grid" role="list" aria-labelledby="hl-gal-h"></div>';
    }
    if (galBox.parentNode !== content) content.appendChild(galBox);
    content.classList.add('hl-has-gal');
    if (galBox.dataset.ready === '1') { galBox.hidden = false; return; }
    if (galBusy) return;
    galBusy = true;
    fetchEmptyPool().then(function (list) {
      var items = (list || []).filter(function (p) { return p.available; }).slice(0, GAL_MAX);
      if (!items.length) { galBox.hidden = true; return; }
      var grid = galBox.querySelector('.hl-gal__grid');
      grid.innerHTML = '';
      items.forEach(function (p) { var c = galCard(p); c.setAttribute('role', 'listitem'); grid.appendChild(c); });
      galBox.dataset.ready = '1';
      galBox.hidden = false;
    }).catch(function () {}).then(function () { galBusy = false; });
  }

  /* The handles in the drawer, in order, read off the line items' own links. */
  function cartHandles(drawer) {
    var out = [];
    var links = drawer.querySelectorAll('.cart-items__title[href*="/products/"]');
    for (var i = 0; i < links.length; i++) {
      var m = links[i].getAttribute('href').match(/\/products\/([^/?#]+)/);
      if (m && out.indexOf(m[1]) === -1) out.push(m[1]);
    }
    return out;
  }

  function productId(handle) {
    if (idCache[handle]) return Promise.resolve(idCache[handle]);
    return fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (!p || !p.id) return null;
        idCache[handle] = p.id;
        return p.id;
      })
      .catch(function () { return null; });
  }

  /* Complementary first — the pairs the merchant set by hand — and related only
     as the fallback. Baymard's finding is that 52% of desktop sites show cart
     cross-sells that are irrelevant, and that ONE bad recommendation erodes
     trust in all of them; asking for the merchant's own pairing first is the
     part of that this file can control. */
  /* Which intent actually answered, per product. fetchMore() needs it so that
     "load thêm" asks for the OTHER list rather than re-requesting the one it has
     already spent — without this it would fetch complementary twice and conclude
     there is nothing more, on every product where complementary is the one that
     worked. */
  /* Which intents have already been ASKED for this product — not which ones
     answered. fetchMore() picks from what is left, and an intent that came back
     empty is just as spent as one that came back full: re-requesting it is a
     round trip whose answer is already known. The first version recorded only
     the intent that supplied the pool, so on every product where complementary
     was empty (which is most of this catalogue) "load thêm" fetched
     complementary a second time and concluded there was nothing more. */
  var recAsked = {};
  function ask(pid, intent) {
    (recAsked[pid] || (recAsked[pid] = {}))[intent] = 1;
    return fetch('/recommendations/products.json?product_id=' + pid +
                 '&limit=10&intent=' + intent)
      .then(function (r) { return r.ok ? r.json() : { products: [] }; });
  }

  function fetchRecs(pid) {
    var key = 'p' + pid;
    if (recCache[key]) return Promise.resolve(recCache[key]);
    return ask(pid, 'complementary')
      .then(function (d) {
        if (d.products && d.products.length) return d;
        return ask(pid, 'related');
      })
      .then(function (d) { recCache[key] = d.products || []; return recCache[key]; })
      .catch(function () { return []; });
  }

  function el(tag, cls, html) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (html != null) n.innerHTML = html;
    return n;
  }

  /* A CARD IS A LINK THAT OPENS THE MODAL, PLUS ITS OWN ADD BUTTON.

     THE LINK. Clicking the card opens hl-blog-pdp-modal over the drawer — the
     real /products/<handle> markup, with its real variant picker — so the
     shopper can choose a size or a colour and add it without leaving the cart:
     "tôi muốn chọn được variant related products luôn trong cart chứ k muốn out
     ra khỏi cart". It is NOT a second quick-view sheet. There is one modal in
     this theme and hl-blog-buybar already drives it; a second implementation is
     a second thing to keep in step, and the sheet this replaces is the surface
     the crosstalk defect lived in.

     The href is real and stays real. window.HLBlogPDP may not be there —
     the asset is deferred, the modal is skipped where <dialog> has no
     showModal — and a card whose only behaviour is a preventDefault'd click is
     a dead card. So the handler opens the modal and only then prevents the
     default; if the modal is absent or its fetch fails, the browser follows the
     link to the product page, which is what the card said it would do.

     THE BUTTON. A separate element, a sibling of the link rather than inside
     it: interactive content nested in an <a> is invalid, and in practice the
     link swallows the button's activation on some engines. Single-variant
     products add straight to the cart; anything with options opens the modal
     instead, because a card cannot honestly "add" a product whose colour has
     not been chosen. Its label says which of the two it will do. */
  function card(p) {
    var wrap = el('div', 'hl-rel-card');
    wrap.dataset.handle = p.handle;

    var img = (p.featured_image || (p.images && p.images[0]) || '');
    if (typeof img === 'object' && img) img = img.src || '';
    /* 90 and 180 are the `thumb` rungs of the ENUM in snippets/hl-img-enum.liquid
       (docs/IMAGE_SIZES.md), sized for a 64px box — which this card now is
       (2026-09-28), so they are the right two. Staying on the ENUM is not only
       about sharpness: a bespoke width is a cold CDN derivative on its first
       request, about 500ms, because nothing else on the store has warmed it.
       Two rungs because 180 on a DPR2.8 screen is a 64px box carrying a 180px
       image.

       Shopify CDN URLs usually already carry ?v=…, but not always — appending a
       bare "&width=" to a URL with no query string yields a 404 image. */
    var w1 = '', w2 = '';
    if (img) {
      var sep = img.indexOf('?') === -1 ? '?' : '&';
      w1 = img + sep + 'width=90';
      w2 = img + sep + 'width=180';
    }

    /* p.price is price_min. A product with a $29 small and a $59 large showed
       "$29" on the card and $59 in the modal, which a shopper reads as bait —
       and it is a pricing claim, not a layout detail. When the range is real the
       card says so; when every variant is one price it stays a plain figure. */
    var lo = p.price_min != null ? p.price_min : p.price;
    var hi = p.price_max != null ? p.price_max : p.price;
    var price = hi > lo ? 'From ' + money(lo) : money(lo);

    /* The struck-through price, which this card never showed. The rail sits in a
       cart whose own line items show one, and every collection card on the store
       shows one, so a suggestion that hides it is the only place a shopper is not
       told what they are saving. Only rendered when it is real and higher — a
       compare-at equal to the price is a data artefact, not a discount, and
       drawing it would be a false claim. */
    var was = p.compare_at_price_min != null ? p.compare_at_price_min : p.compare_at_price;
    var wasHtml = (was != null && was > lo)
      ? '<s class="hl-rel-card__was">' + money(was) + '</s> ' : '';

    var a = el('a', 'hl-rel-card__link');
    a.href = '/products/' + p.handle;
    a.innerHTML =
      '<span class="hl-rel-card__img">' +
        (img ? '<img src="' + w1 + '" srcset="' + w1 + ' 1x, ' + w2 + ' 2x"'
             + ' alt="" loading="lazy" width="64" height="64">' : '') +
      '</span>' +
      '<span class="hl-rel-card__text">' +
        '<span class="hl-rel-card__title"></span>' +
        '<span class="hl-rel-card__price">' + wasHtml +
          '<span class="hl-rel-card__now">' + price + '</span></span>' +
      '</span>';
    a.querySelector('.hl-rel-card__title').textContent = p.title;
    a.setAttribute('aria-label', p.title + ', ' + price);
    /* PREVENT FIRST, THEN FALL BACK — the reverse of what this did.
       openModal() returned true synchronously while HLBlogPDP.open() returns a
       PROMISE, and the modal resolves false and closes itself when the fetch or
       the markup extraction fails. So a card whose /products/<handle> could not
       be fetched flashed the dialog open, shut it, and had already cancelled the
       navigation its href promised: a dead click, with the comment above it
       stating the opposite contract.

       The link is only hijacked when there is a modal to hijack it for, and if
       that modal reports it could not render, the browser is sent to the product
       page after all. p.title goes with it so the modal's breadcrumb says the
       product's name instead of the literal "Product" its fallback uses. */
    /* The fetch starts when the finger lands, not when it lifts — ~100-200ms
       of head start on the product markup, so the sheet more often arrives
       to content rather than to a skeleton. */
    var warm = function () {
      var pdp = window.HLBlogPDP;
      if (pdp && typeof pdp.prefetch === 'function') pdp.prefetch(p.handle);
    };
    a.addEventListener('pointerdown', warm, { passive: true });
    a.addEventListener('click', function (e) {
      var pdp = window.HLBlogPDP;
      if (!pdp || typeof pdp.open !== 'function') return;   // let the link be a link
      e.preventDefault();
      var go = function () { window.location.href = a.href; };
      try {
        Promise.resolve(pdp.open(p.handle, { title: p.title, half: true })).then(function (ok) {
          if (ok === false) go();
        }, go);
      } catch (err) { go(); }
    });
    wrap.appendChild(a);

    /* NO SECOND ROW ANY MORE, 2026-09-23 — owner: "relate product cần tiết kiệm
       height hơn, đưa giá và button call to action lên trong khung ảnh product
       luôn chứ k để xuống dưới như hiện tại".

       The price goes back inside the link, under the title, and the add control
       is laid over the bottom of the thumbnail. The card is then exactly as tall
       as its image — 76px against the 106px it was — because nothing sits below
       the picture any more.

       The price being inside the link again does put it in the anchor's
       accessible name, which is why it was taken out before. That is accepted
       here: the aria-label set below states the title and the price explicitly,
       so the name a screen reader announces is authored rather than accidental. */
    var single = p.variants && p.variants.length === 1 && p.variants[0].available;
    var btn = el('button', 'hl-rel-add');
    btn.type = 'button';
    btn.setAttribute('aria-label', (single ? 'Add ' : 'Choose options for ') + p.title);
    btn.title = single ? 'Add to cart' : 'Choose options';
    /* A LABEL, NOT JUST A GLYPH. Owner: "nút add to cart icon kèm call to action".
       A bag on its own asks the shopper to guess; the word removes the guess, and
       on a card this wide there is room for it. "Options" rather than "Add" when
       the product has variants, because that button does not add anything — it
       opens the picker, and a button that says Add and does not add is the worst
       version of this control. */
    btn.innerHTML = ICON_BAG + '<span class="hl-rel-add__t">' +
      (single ? 'Add' : 'Options') + '</span>';
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (!single) {
        var pdp = window.HLBlogPDP;
        if (!pdp || typeof pdp.open !== 'function') { window.location.href = a.href; return; }
        var go = function () { window.location.href = a.href; };
        try {
          Promise.resolve(pdp.open(p.handle, { title: p.title, half: true })).then(function (ok) {
            if (ok === false) go();
          }, go);
        } catch (err) { go(); }
        return;
      }
      if (btn.disabled) return;
      btn.disabled = true;
      /* Same spinner as every other add-to-cart (snippets/hl-atc-busy), until the
         line is in the cart; done()/failed() replace the button's contents. */
      btn.setAttribute('data-hl-atcb', '1');
      var spin = document.createElement('span'); spin.className = 'hl-atcb__spin'; spin.setAttribute('aria-hidden', 'true');
      btn.appendChild(spin);
      addToCart(p.variants[0].id, btn);
    });
    wrap.appendChild(btn);
    return wrap;
  }

  /* ADDING FROM A CARD HAS TO REDRAW THE DRAWER, and /cart/add.js on its own
     does not: it changes the cart, while Horizon re-renders
     .cart-drawer__inner only from responses to its OWN section requests. That
     was measured earlier in the week — a bare add left the line items and the
     total a step behind, which is why this file's cards were links only until
     the owner asked for a button.

     The Cart AJAX API answers that: `sections` on the add request returns the
     rendered section, and swapping .cart-drawer__inner is what the theme does
     with it. The dialog itself is not replaced, so the drawer stays open and
     the custom elements inside re-initialise on connect.

     THE JUST-ADDED PRODUCT DROPS OUT OF THE RAIL, and not by a special case:
     the redraw gives the drawer a new line item, render() reads handles off the
     line items, and the filter already excludes anything whose handle is in the
     cart. The seed moves to the product just added, so the next four
     suggestions are its complements. That is the same path as adding from a
     product page, which is what the owner asked the rail to follow.

     IT CANNOT RESTART THE /cart.js LOOP. Nothing here reads /cart.js at all,
     and the redraw only causes a rebuild if the product-id list actually
     changes (rail.dataset.hlKey). cart_idle_test holds this at 0 requests in 15
     idle seconds. */
  function addToCart(variantId, btn) {
    /* THE SAME PATH AS THE PRODUCT PAGE, 2026-09-23. The theme's product form
       dispatches a CartLinesUpdateEvent whose promise resolves with the section
       HTML; cart-items-component then morphs the drawer and animates the new
       row. Doing the same here — instead of swapping .cart-drawer__inner — is
       what makes a rail add look like any other add, and it also updates the
       header count and anything else listening for the theme's event. */
    var unspin = function () {
      btn.removeAttribute('data-hl-atcb');
      var s = btn.querySelector('.hl-atcb__spin'); if (s) s.remove();
    };
    var failed = function () {
      unspin();
      btn.disabled = true;
      btn.classList.add('is-gone');
      btn.setAttribute('aria-label', 'Unavailable');
      btn.title = 'Unavailable';
      btn.innerHTML = ICON_GONE;
    };
    var done = function () {
      unspin();
      btn.classList.add('is-done');
      btn.innerHTML = ICON_TICK;
      motion(btn, [{ transform: 'scale(.8)' }, { transform: 'scale(1.08)' }, { transform: 'none' }], 320);
    };
    var post = function () {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: variantId, quantity: 1 }],
          sections: 'cart-drawer-section',
          sections_url: window.location.pathname,
        }),
      }).then(function (r) { return r.json(); });
    };
    import('@shopify/events').then(function (m) {
      var E = m.CartLinesUpdateEvent;
      var deferred = E.createPromise();
      btn.dispatchEvent(new E({
        action: 'add',
        context: 'product',
        lines: [{ merchandiseId: String(variantId), quantity: 1 }],
        promise: deferred.promise,
      }));
      return post().then(function (resp) {
        return fetch('/cart.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            var bad = !!resp.status;
            deferred.resolve({
              cart: E.createCartFromAjaxResponse(cart),
              detail: {
                items: cart.items,
                source: 'hl-cart-related',
                itemCount: 1,
                sections: bad ? undefined : resp.sections,
                didError: bad,
              },
            });
            if (bad) failed(); else done();
          });
      }).catch(function (err) {
        deferred.reject(err);
        unspin();
        btn.disabled = false;
      });
    }).catch(function () {
      // No import map (should not happen on this theme): the old swap.
      post().then(function (d) {
        if (d.status) { failed(); return; }
        var html = d.sections && d.sections['cart-drawer-section'];
        if (html) {
          var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('.cart-drawer__inner');
          var live = document.querySelector('#cart-drawer .cart-drawer__inner');
          if (fresh && live) live.replaceWith(fresh);
        }
        done();
        schedule();
      }).catch(function () { btn.disabled = false; });
    });
  }

  /* ---- MOTION, 2026-09-23 ------------------------------------------------
     Owner: "khi add to cart bằng relate products, animation cần như add to cart
     bth từ PDP, mượt và không được giật giật, nhất là đoạn chờ load thêm
     products, khi load thêm, height thay đổi, cần animation mượt".

     Recorded before this, adding from the rail: the rail vanished for 3.6s (the
     whole drawer inner was swapped, rail included), came back as a fresh box at
     card 1, and the tick on the button was never on screen. Adding from a sheet
     went through the theme's morph, which also drops the rail (it is not in the
     server HTML), and render() then rebuilt it 90ms later — a visible gap.

     So: ONE rail node for the life of the page. When a morph removes it, the
     observer puts the same node back in the same microtask — before paint, so
     there is no frame without it — with its cards and scroll position intact.
     Everything the shopper sees change is animated with transform/opacity only. */
  var railBox = null;      // the one rail node, kept across morphs
  var savedLeft = 0;       // track scroll position, survives a detach
  var reduce = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };
  var EASE = 'cubic-bezier(.2,.7,.3,1)';
  function motion(node, frames, ms, delay) {
    if (reduce.matches || !node.animate) return null;
    try { return node.animate(frames, { duration: ms, delay: delay || 0, easing: EASE, fill: 'backwards' }); }
    catch (e) { return null; }
  }
  function fadeIn(nodes, dx) {
    for (var i = 0; i < nodes.length; i++) {
      motion(nodes[i], [
        { opacity: 0, transform: 'translateX(' + (dx || 0) + 'px)' },
        { opacity: 1, transform: 'none' }
      ], 260, i * 45);
    }
  }

  /* Put the rail where it belongs, synchronously. Cheap enough to run on every
     drawer mutation: it only writes when the node is detached or in the wrong
     seat. Returns true when it wrote. */
  function reseat(drawer) {
    if (!railBox) return false;
    var handles = cartHandles(drawer);
    if (!handles.length) {
      if (railBox.isConnected) railBox.remove();
      return false;
    }
    var seat = seatFor(drawer, handles.length);
    if (!seat) return false;
    var name = handles.length >= 2 ? 'I' : 'S';
    var placed = railBox.parentNode === seat.parent && railBox.nextElementSibling === seat.before;
    if (placed) return false;
    var moved = railBox.dataset.seat && railBox.dataset.seat !== name;
    railBox.classList.toggle('hl-rel--incart', name === 'I');
    railBox.dataset.seat = name;
    seat.parent.insertBefore(railBox, seat.before);
    var track = railBox.querySelector('.hl-rel__track');
    if (track && savedLeft) track.scrollLeft = savedLeft;
    // A seat change is a real move (summary -> end of the list at two lines):
    // it arrives rather than appears. A re-insert after a morph is invisible.
    if (moved) {
      motion(railBox, [
        { opacity: 0, transform: 'translateY(10px)' },
        { opacity: 1, transform: 'none' }
      ], 280, 60);
    }
    return true;
  }

  /* AN <aside>, AND BOTH OF THE OBVIOUS REASONS FOR IT ARE WRONG. Read this
     before changing the tag a third time.

     The first reason given was a mispairing: morph.js's same() pairs elements on
     tagName alone unless BOTH carry a key, so a <div> here was predicted to be
     paired with .cart-actions and to push the subtotal and total off the end.
     MEASURED AND FALSE. tools/cart_morph_test.mjs reproduces the exact shape and
     the totals never disappear; they are removed and re-inserted either way,
     which is simply how this morph replaces that container.

     The second reason, once the first collapsed, was that the <aside> should go
     back because it costs extra churn — it makes the morph remove and re-add
     .cart-actions, the block holding the discount input, and a re-added node
     cannot keep what a shopper had typed. ALSO MEASURED, ALSO FALSE, AND IT IS
     BACKWARDS. tools/cart_discount_input_test.mjs types SAVE1 into the discount
     field and changes a line quantity, twice per build:

         as <aside>   removed: cart-actions, cart-totals__container, hl-rel
                      value KEPT ("SAVE1"), focus lost
         as <div>     removed: cart-totals__container
                      value LOST (""), focus lost

     The <aside> is the one that keeps the half-typed code. When .cart-actions is
     torn out and put back it is the SAME node going back, carrying its live
     value; when it is morphed in place the morph reconciles the input back to
     the server-parsed value — empty — and data-skip-node-update does not save it.
     Focus is lost either way, so the <div> buys nothing and costs the code.

     Reverted to <div> on instruction and restored on the measurement, which is
     the order those two things belong in. */
  function build() {
    var box = el('aside', 'hl-rel');
    box.id = 'hl-rel';
    box.innerHTML =
      '<p class="hl-rel__h" id="hl-rel-h">You may also like</p>' +
      '<div class="hl-rel__track" tabindex="0" role="group" aria-labelledby="hl-rel-h"></div>';
    var track = box.querySelector('.hl-rel__track');
    for (var i = 0; i < 3; i++) track.appendChild(el('span', 'hl-rel-skel'));
    track.addEventListener('scroll', function () { savedLeft = track.scrollLeft; }, { passive: true });
    railBox = box;
    return box;
  }

  /* WHERE THE RAIL GOES DEPENDS ON HOW FULL THE CART IS, 2026-09-14.

     Owner: "them relate products o duoi cung (tren payments)" and then "neu nhu
     tren UI cart co >= 2 item doc lap => relate cart se duoc bo pin fixed duoi
     payent ma no se noi kem products list thanh mot cum".

     Two seats, one rule:

       ONE line item  -> first child of .cart-drawer__summary. The summary is the
                         block pinned to the bottom of the drawer, so the rail is
                         pinned with it, sitting directly above Estimated total
                         and the checkout and wallet buttons. With one product in
                         a tall drawer there is nothing but empty cream between
                         the line and the total, and this is what fills it.

       TWO OR MORE    -> last child of the scrolling item list, so it reads as
                         the end of the products rather than as a second block
                         bolted under the total. It scrolls away with them, which
                         is the "mot cum" (one cluster) the owner asked for, and
                         it stops the pinned block growing tall enough to crowd
                         the items it is meant to be under.

     The seat is recomputed on every pass because the count changes under the
     rail: remove the second product and it has to climb back into the summary. */
  function seatFor(drawer, count) {
    if (count >= 2) {
      var list = drawer.querySelector('.cart-drawer__items .cart-items__wrapper')
              || drawer.querySelector('.cart-drawer__items');
      if (list) return { parent: list, before: null };
    }
    var summary = drawer.querySelector('.cart-drawer__summary');
    if (summary) {
      var first = summary.firstElementChild;
      /* SKIP THE RAIL ITSELF. This line is why the rail would not scroll,
         2026-09-22. Once seated it IS summary.firstElementChild, so `before`
         became the box, and render()'s guard reduced to
         `box.nextElementSibling !== box` — true forever. Every observer pass
         therefore ran insertBefore(box, box), re-inserting a node that was
         already in the right place, and re-inserting a scroll container resets
         its scrollLeft to 0. Measured: a programmatic scrollLeft = 200 read back
         as 231 (snapped, so the track was scrollable all along) and was 0 again
         within 400ms. From a finger that is a rail that refuses to move and
         judders while it does it. */
      if (first && first.classList && first.classList.contains('hl-rel')) {
        first = first.nextElementSibling;
      }
      return { parent: summary, before: first };
    }
    return null;
  }

  /* ---------- load thêm ----------
     State for the growing rail. Module-scoped because there is exactly one cart
     drawer and one rail in it; render() resets all three whenever the product
     set changes, which is the only moment the pool means something different. */
  var pool = [];          // every eligible recommendation, in order
  var shown = 0;          // how many of them are on the track
  var exhausted = false;  // the second intent has been asked for and gave nothing new
  var lastPid = null;     // the product the pool was built from
  var growing = false;

  /* Draw up to `upto` cards from the pool. Idempotent on `shown`, so a scroll
     event that fires twice in a frame cannot double-append. */
  function growFrom(track, upto, animate) {
    var end = Math.min(upto, pool.length, MAX_CARDS);
    var added = [];
    for (; shown < end; shown++) {
      var c = card(pool[shown]);
      track.appendChild(c);
      added.push(c);
    }
    // Appended by load-more: each new card slides in from the right, a beat
    // apart, instead of the strip snapping longer.
    if (animate && added.length) fadeIn(added, 16);
    return shown;
  }

  /* The pool came from ONE intent — complementary when the merchant set pairs,
     related otherwise. When the shopper scrolls past all of it, ask the other
     one before giving up. Deduped against both the pool and the cart, so the
     appended tail cannot repeat a card already on the track or suggest something
     already bought. Runs at most once per product set; `exhausted` makes a rail
     that has nothing more to give stop asking. */
  function fetchMore(track) {
    if (exhausted || !lastPid) return Promise.resolve(false);
    exhausted = true;
    var used = {};
    pool.forEach(function (p) { used[p.id] = 1; });
    var drawer = document.getElementById('cart-drawer');
    var inCart = drawer ? cartHandles(drawer) : [];
    /* Whichever intent has not been asked yet. When fetchRecs already fell back
       to `related` there is nothing left to ask, and the rail is simply as long
       as it gets. */
    var asked = recAsked[lastPid] || {};
    var other = !asked.related ? 'related' : (!asked.complementary ? 'complementary' : null);
    if (!other) return Promise.resolve(false);
    return ask(lastPid, other)
      .then(function (d) {
        var add = (d.products || []).filter(function (p) {
          return p.available && !used[p.id] && inCart.indexOf(p.handle) === -1;
        });
        if (!add.length) return false;
        pool = pool.concat(add);
        return true;
      })
      .catch(function () { return false; });
  }

  function maybeMore(track) {
    if (growing || shown >= MAX_CARDS) return;

    /* The rail must be overflowing before any of this means anything. Without
       this test the FIRST call grew the rail on its own: armMore() runs
       immediately after the cards are appended, and at that instant the images
       have not laid out, so scrollWidth is still ~clientWidth and `room`
       computes to 0 — which reads exactly like "scrolled to the end". Measured
       on the preview: the rail went 4 -> 8 cards with scrollLeft never leaving
       0. It also correctly does nothing when four small cards happen to fit the
       track, where there is no scrolling to reward and everything is already
       visible. */
    if (track.scrollWidth - track.clientWidth < 24) return;

    var room = track.scrollWidth - track.clientWidth - track.scrollLeft;
    if (room > MORE_AHEAD) return;

    if (shown < Math.min(pool.length, MAX_CARDS)) { growFrom(track, shown + MORE_STEP, true); return; }
    if (exhausted) return;

    growing = true;
    fetchMore(track).then(function (gotMore) {
      growing = false;
      if (gotMore) growFrom(track, shown + MORE_STEP, true);
    });
  }

  /* One listener per track element, kept across rebuilds: render() replaces the
     track's children, not the track itself, so re-binding on every pass would
     stack listeners on the same node. */
  function armMore(track) {
    if (track.dataset.hlMore === '1') { maybeMore(track); return; }
    track.dataset.hlMore = '1';
    track.addEventListener('scroll', function () {
      if (track._hlRaf) return;
      track._hlRaf = requestAnimationFrame(function () {
        track._hlRaf = 0;
        maybeMore(track);
      });
    }, { passive: true });
    /* A track that is not overflowing has no scroll to wait for. On a wide
       drawer four small cards can fit without a scrollbar, and then the rail
       would never grow past them. */
    maybeMore(track);
  }

  /* A NEW SET REPLACES THE OLD ONE WITHOUT A HOLE. The old cards stay on
     screen until the new set is known (the fetch is already done by the time
     this runs), fade out together, and the new ones slide in behind them. The
     track keeps its height throughout — every card and skeleton is 76px — so
     nothing below it moves. */
  function swapCards(track) {
    var old = [].slice.call(track.children);
    var fromSkeleton = !old.length || track.querySelector('.hl-rel-skel');
    var fill = function () {
      track.innerHTML = '';
      track.scrollLeft = 0;
      savedLeft = 0;
      shown = 0;
      exhausted = false;
      growFrom(track, CARDS);
      fadeIn([].slice.call(track.children), fromSkeleton ? 0 : 16);
      armMore(track);
    };
    if (fromSkeleton || reduce.matches || !track.animate) { fill(); return; }
    var a = track.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 140, easing: 'ease-out' });
    a.onfinish = fill;
    a.oncancel = fill;
  }

  function render() {
    var drawer = document.getElementById('cart-drawer');
    if (!drawer) return;

    var handles = cartHandles(drawer);
    if (!handles.length) {
      if (railBox && railBox.isConnected) railBox.remove();
      /* an empty cart has no seed for recommendations: it shows a plain gallery of best sellers */
      if (isEmptyDrawer(drawer)) renderGallery(drawer); else removeGallery();
      return;
    }
    removeGallery();
    if (!railBox) build();
    var box = railBox;
    reseat(drawer);

    var track = box.querySelector('.hl-rel__track');
    /* A REFRESH THAT ARRIVES MID-FETCH IS RE-QUEUED, NOT DROPPED. `if (busy)
       return` threw it away, and on a first open that is visible: the drawer
       renders, render() starts the /products/<handle>.js + /recommendations
       round trip, the theme morphs the drawer a moment later and that pass is
       swallowed — leaving the three grey skeletons on screen with nothing ever
       coming to replace them. */
    if (busy) { pending = true; return; }
    busy = true;

    productId(handles[handles.length - 1]).then(function (pid) {
      if (!pid) return [];
      lastPid = pid;
      return fetchRecs(pid);
    }).then(function (products) {
      /* The whole eligible set is kept on the track; only the first CARDS of it
         are drawn. growFrom() below draws the rest as the shopper scrolls, which
         is the difference between a rail that ends after four and one that keeps
         going. Filtering stays here so what is parked is already cart-aware — a
         product added to the cart while the rail is open drops out of the pool
         on the next pass rather than being appended later as a suggestion to buy
         something already bought. */
      var list = (products || []).filter(function (p) {
        return p.available && handles.indexOf(p.handle) === -1;
      });
      if (!list.length) { box.hidden = true; return; }
      box.hidden = false;
      pool = list;

      /* REBUILD ONLY WHEN THE SET CHANGED. The key is the product ids in order,
         so what it notices is the SET moving — which is exactly the owner's
         "load more when another item is added", and nothing else. An item going
         out of stock comes through, because it is filtered out above and the key
         changes with it. A price-only change does not: the ids are identical and
         the card keeps the price it was drawn with. That is accepted — the price
         on a suggestion is a lure and the cart re-prices from the server — but it
         should not be discovered from the code.

         Without this the rail cleared and re-appended on every pass, which also
         dropped keyboard focus placed on a card and let a tap land in the gap
         between the clear and the re-append. */
      var key = list.map(function (p) { return p.id; }).join(',');
      if (track.dataset.hlKey === key && !track.querySelector('.hl-rel-skel')) return;
      track.dataset.hlKey = key;
      swapCards(track);
    }).catch(function () {}).then(function () {
      busy = false;
      if (pending) { pending = false; schedule(); }
    });
  }

  var timer;
  function schedule() { clearTimeout(timer); timer = setTimeout(render, 90); }

  function start() {
    var drawer = document.getElementById('cart-drawer');
    if (!drawer) return false;
    new MutationObserver(function (muts) {
      // Before anything else and before paint: a morph that just took the rail
      // out gets the same node back in this microtask.
      if (railBox && (!railBox.isConnected || !drawer.contains(railBox))) reseat(drawer);
      for (var i = 0; i < muts.length; i++) {
        var t = muts[i].target;
        // Our own writes. Without this the rail's own re-insert is a drawer
        // mutation, which schedules a render, which re-inserts.
        if (t && t.closest && t.closest('.hl-rel, .hl-gal')) continue;
        schedule();
        return;
      }
    }).observe(drawer, { childList: true, subtree: true });
    /* NOT schedule() HERE. This ran on load, so a shopper with a non-empty cart
       paid /products/<handle>.js and /recommendations on EVERY page view with the
       drawer shut — two requests for a rail nobody had asked to see. The first
       draw now waits for the drawer to actually open. The observer above still
       catches every later change, and the dialog's own [open] attribute is the
       signal, so nothing has to guess at the theme's event names. */
    var dlg = drawer.querySelector('dialog');
    if (dlg) {
      if (dlg.hasAttribute('open')) schedule();
      new MutationObserver(function () {
        if (dlg.hasAttribute('open')) schedule();
      }).observe(dlg, { attributes: true, attributeFilter: ['open'] });
    } else {
      schedule();
    }
    return true;
  }

  if (!start()) {
    var tries = 0;
    var iv = setInterval(function () { if (start() || ++tries > 20) clearInterval(iv); }, 300);
  }

  // The theme's own add path dispatches these; they are how "another item was
  // added" reaches this file without anything polling for it.
  document.addEventListener('cart:update', schedule);
  document.addEventListener('cart:lines:update', schedule);
})();
